// extracted by mini-css-extract-plugin
export default {"Consultant":"Consultant_Consultant__9liaC","List":"Consultant_List__mUAd0","TableWrapper":"Consultant_TableWrapper__4Yh7f"};